module.exports = __webpack_public_path__ + "img/free_spinsrules.16aa3a65.png";